module.exports = __webpack_public_path__ + "img/reget-active.0d35e3d7.svg";